var _path, _circle, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderPickLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4987 69.1333L39.3033 55.4083H21.6941L30.4987 69.1333Z",
    fill: "#0D0C22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.25,
    fill: "#0D0C22",
    stroke: "#0D0C22",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9373 18H43.1842C43.7021 18 44.1215 18.5179 44.1215 18.9373V21.7496C44.1215 22.2675 43.7017 22.6869 43.1842 22.6869H16.9373C16.4194 22.6869 16 22.1691 16 21.7496V18.9373C16 18.4194 16.4198 18 16.9373 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6191 24.252H18.4982C17.9807 24.252 17.5609 24.6718 17.5609 25.1894V40.8111C17.5622 41.3914 17.793 41.9472 18.2033 42.3576C18.6136 42.7679 19.1694 42.9987 19.7498 43H40.3724C40.9517 42.9977 41.5065 42.7659 41.9158 42.3559C42.3248 41.946 42.5553 41.3905 42.5566 40.8112V25.1894C42.5566 24.9409 42.4578 24.7026 42.282 24.5267C42.1061 24.3508 41.8677 24.2521 41.6193 24.2521L41.6191 24.252ZM34.7479 29.5624C34.7479 29.8109 34.6491 30.0496 34.4732 30.2251C34.2977 30.401 34.059 30.4998 33.8105 30.4998H26.3113C25.7937 30.4998 25.374 30.08 25.374 29.5625V28.311C25.374 27.7934 25.7937 27.3737 26.3113 27.3737H33.8105C34.059 27.3737 34.2977 27.4724 34.4732 27.6483C34.6491 27.8238 34.7479 28.0625 34.7479 28.311V29.5624Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPickLogo);
export default __webpack_public_path__ + "static/media/order_pick_logo.78961dc5ec895534318a2ff1a5f76ffa.svg";
export { ForwardRef as ReactComponent };